define.alias("shared/decorators/track-call-duration", "calendar/decorators/track-call-duration");